
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/Login";
import Support from "./components/Support";
import AdminLogin from "./components/Admin/AdminLogin";
import StudentDashboard from "./components/Students/StudentDashboard"


import Dashboard from "./components/Admin/Dashboard";
import Classes from "./components/Admin/Classes";
import Teacher from "./components/Admin/Teacher";
import Student from "./components/Admin/Student";
import Question from "./components/Admin/Question";
import AdminLayout from "./components/Admin/AdminLayout";
import Inquiry from "./components/Admin/Inquiry";
import Pnf from "./components/General/pnf";
import ForgetPassword from "./components/Forgetpassword";
import StudentLayout from "./components/Students/StudentLayout";
import Exams from "./components/Students/Exams";
import ExamResult from "./components/Admin/ExamResult";
import Admin_forget_password from "./components/Admin/Admin_forget_password";
import Results from "./components/Admin/Results";


function App() {

        const data = localStorage.getItem("admin");
        const admin = JSON.parse(data);
         
       

        const stData = localStorage.getItem("student");
        const student = JSON.parse(stData);


        return (

                <Routes>

                        {!admin && !student && <>
                                <Route path="/" element={<Login />} />
                                <Route path="/forget-password" element={<ForgetPassword />} />

                                <Route path="/support" element={<Support />} />
                                <Route path="/admin-login" element={<AdminLogin />} />
                                  <Route path="/admin-forget-password" element={<Admin_forget_password />} />
                                {/* <Route path="*" element={<Pnf admin={admin} />} /> */}
                                <Route path="*" element={<Navigate to="/" replace />} />
                        </>}

                        {/* Admin Protected Routes */}
                        {admin != null && <>
                                <Route
                                        path="/admin"
                                        element={<AdminLayout admin={admin} />}
                                >
                                        {/* <AdminLayout /> */}
                                        <Route path="/admin/dashboard" element={<Dashboard admin={admin}/>} />
                                        <Route path="/admin/classes" element={<Classes admin={admin} />} />

                                        {admin.role == 'admin' && <Route path="/admin/teacher" element={<Teacher />} />}
                                        <Route path="/admin/student" element={<Student admin={admin} />} />
                                        <Route path="/admin/question-bank" element={<Question admin={admin} />} />
                                        <Route path="/admin/inquiry" element={<Inquiry />} />

                                        <Route path="/admin/exam-result" element={<ExamResult />} />
                                                         <Route path="/admin/result" element={<Results/>} />

                                </Route>
                                {/* <Route path="*" element={<Pnf admin={admin} />} /> */}
                                <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                        </>}

                        {student != null && <>
                                <Route
                                        path="/student"
                                        element={<StudentLayout student={student} />}
                                >

                                        <Route path="/student/dashboard" element={<StudentDashboard student={student} />} />

                                        <Route path="/student/exam" element={<Exams student={student} />} />


                                </Route>
                                {/* <Route path="*" element={<Pnf student={student} />} /> */}
                                <Route path="*" element={<Navigate to="/student/dashboard" replace />} />
                        </>}


                </Routes>

        );
}

export default App;